export default "__VITE_ASSET__CgLalh8E__"